import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { injectIntl } from 'react-intl'

const Wrapper = styled.div`
  border: 1px solid #ccc;
  border-radius:10px;
  margin: 10px 15px 0;
`

const TextArea = styled.textarea`
  width: 100%;
  border: none;
  border-radius:10px;
  resize: none;
  padding:10px;
  outline: none;
  font-size:0.9rem;
`

const Buttons = styled.div`
  padding: 5px 0;
  display:flex;
  justify-content:space-between;
  width:100%;
  border-top: 1px solid #ccc;
`

const BtnsLeft = styled.div``

const BtnsRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

const Btn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius:5px;
  font-size:0.9rem;
  width: 30px;
  height: 30px;
  background-color: transparent;

  &:hover {
    background-color: #ddd;
  }

  &:focus {
    outline: none;
  }

  &:last-child {
    margin-right: 5px;
  }
`

const Icon = styled.em`
  color: #000;

  ${Btn}:disabled & {
    opacity: 0.5;
  }
`

export default injectIntl((props) => {
  const { rows = 2,addNote : _addNode,type } = props;

  const [note, setNote] = useState('')

  const addNote = useCallback(() => {
    _addNode({ note, noteType: type })
    setNote('')

  }, [note,_addNode,type])

  const onKeyDown = e => e.which === 13 && !e.shiftKey && e.target.value.length && addNote()

  return (
    <Wrapper>
      <TextArea rows={rows} value={note} onChange={(e) => setNote(e.target.value)} onKeyDown={onKeyDown} />
      <Buttons>
        <BtnsLeft>
        </BtnsLeft>
        <BtnsRight>
          {/* <Btn><Icon className="far fa-paperclip" /></Btn> */}
          <Btn onClick={addNote} disabled={note.length === 0}><Icon className="fal fa-paper-plane" /></Btn>
        </BtnsRight>
      </Buttons>
    </Wrapper>
  )
})